import { Avatar } from "@dash/avatar";
import { Card, Header2 } from "@dash/page";
import { useNavigate } from "react-router-dom-v5-compat";

import { GoToVisitsButton } from "./GoToVisitsButton";
import { RealizationProgressBar } from "./RealizationProgressBar";
import { ExtendedRegion } from "./RegionsTable";
import { getMegaraxPath } from "@megaron/megarax-uri";

type Props = {
  region: ExtendedRegion;
  queryKey: string | string[];
};

export const RegionTile: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { region, profile, profitMetrics, legacyUserId } = props.region;

  return (
    <Card
      variant="secondary"
      css={{ cursor: "pointer" }}
      onClick={() => navigate(getMegaraxPath.uri("megarax://crm/regions/id/{id}", { id: region.name }))}
    >
      <div css={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <Header2 css={{ fontSize: "16px", fontWeight: "bold" }}>{region.name}</Header2>
          <span css={{ color: "black" }}>
            {region.customerCount} {region.customerCount === 1 ? "klient" : "klientów"}
          </span>
        </div>
        <div css={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
          <span css={{ textAlign: "right" }}>
            {profile?.firstName} {profile?.lastName}
          </span>
          <Avatar src={profile ? profile.profilePictureUrl : null} />
          {legacyUserId && <GoToVisitsButton legacyUserId={legacyUserId} />}
        </div>
      </div>
      {profitMetrics.profit && profitMetrics.target && (
        <RealizationProgressBar
          currentRealization={profitMetrics.profit?.toNumber()}
          goalRealization={profitMetrics.target?.toNumber()}
        />
      )}
    </Card>
  );
};
